import { BlobServiceClient, AnonymousCredential } from "@azure/storage-blob";

class AzureBlobStorageClient {
  sasUrl;
  container;
  constructor(sasUrl, container = null) {
    this.sasUrl = sasUrl;
    this.container = container || process.env.REACT_APP_AZURE_CONTAINER;
  }
  upload = async (blob, fileName, blockId = null) => {
    try {
      console.log("[AzureBlobStorage] Starting block staging/uploading:", {
        fileName,
        blockId,
        blobSize: blob.size,
        container: this.container,
        hasSasUrl: !!this.sasUrl,
      });

      let blobServiceClient = new BlobServiceClient(
        this.sasUrl,
        new AnonymousCredential()
      );
      let containerClient = blobServiceClient.getContainerClient(
        this.container
      );
      const blockBlobClient = containerClient.getBlockBlobClient(fileName);

      // Stage the block with the provided block ID
      let response;
      if (blockId) {
        response = await blockBlobClient.stageBlock(blockId, blob, blob.size);
      } else {
        response = await blockBlobClient.uploadData(blob);
      }
      console.log("[AzureBlobStorage] Block staged successfully:", {
        fileName,
        blockId,
        requestId: response.requestId,
        blobSize: blob.size,
        timestamp: new Date().toISOString(),
      });

      return response;
    } catch (error) {
      console.error("[AzureBlobStorage] Error staging block:", {
        fileName,
        blockId,
        error: error.message,
        stack: error.stack,
        blobSize: blob?.size || 0,
      });
      throw error;
    }
  };
}

export default AzureBlobStorageClient;
